import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { BaseAgentTypeaheadService } from './';

@Injectable()
export class AgentCodeTypeaheadService extends BaseAgentTypeaheadService {
    constructor(http: Http) {
        super(http);
    }

    public getSearchType(): string {
        return this.agentCodeSearch;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/services/agent-code-typeahead.service.ts